import { PublicSession } from '@/models/session/types'
import { isEmptyOrNull } from '@/utils'
import { getReferralData } from '@/hooks/use-referral-data'

import { ContinueData, FormProps, Provider, Social } from './login-modal/types'

export const formatFullName = (str: string) => {
  const trimmedName = str.trim()
  const firstName = trimmedName.split(' ').slice(0, -1).join(' ')
  const lastName = trimmedName.split(' ').pop()
  return [firstName, lastName]
}

export const isSocialRegistration = (social: Social) => !isEmptyOrNull(social)

export const formatUserRegistrationValues = (
  values: FormProps,
  social: Social
) => {
  const referralData = getReferralData()
  const isSocial = isSocialRegistration(social)
  const isLandlord = values.account_type === 'landlord'
  const [firstName, lastName] = formatFullName(values.full_name || '')
  if (isSocial) {
    return {
      first_name: firstName === '' ? values.first_name : firstName,
      last_name: lastName === '' ? values.last_name : lastName,
      email: values.username ?? values.email,
      token: social?.data?.access_token,
      authorizationCode: social?.data?.authorization_code,
      operation_type: values.account_type,
      agree_to_terms: true,
      referral_data: referralData
    }
  }
  if (isLandlord) {
    return {
      first_name: firstName === '' ? values.first_name : firstName,
      last_name: lastName === '' ? values.last_name : lastName,
      email: values.username ?? values.email,
      password: values.password,
      allow_renter_call: false,
      agree_to_terms: true,
      referral_data: referralData
    }
  }
  return {
    first_name: firstName === '' ? values.first_name : firstName,
    last_name: lastName === '' ? values.last_name : lastName,
    email: values.username ?? values.email,
    password: values.password,
    password_confirm: values.password,
    agree_to_terms: true,
    referral_data: referralData
  }
}

export const getSubmitEventId = (
  eventId: string,
  method?: Provider,
  accountType?: string
) => {
  const account = accountType === 'landlord' ? 'landlord' : 'renter'
  return `${eventId}-${method}-${account}`
}

export const getInitialFullName = (
  data: Partial<ContinueData>,
  social: Social,
  publicChatSession: PublicSession
) => {
  if (data?.first_name) {
    return `${data?.first_name} ${data?.last_name}`
  }
  if (social?.data?.user_profile?.fullName) {
    return `${social?.data?.user_profile?.fullName}`
  }
  if (social?.data?.user_profile?.firstName) {
    return `${social?.data?.user_profile?.firstName} ${social?.data?.user_profile?.lastName}`
  }
  if (publicChatSession?.first_name) {
    return `${publicChatSession?.first_name} ${publicChatSession?.last_name}`
  }
  return ''
}
